module.exports = __webpack_public_path__ + "media/images/close-d27dfa0f481acc996ff5169452361d81.svg";